if (!customElements.get('featured-collection-group-swiper')) {
    class FeaturedCollectionGroupSwiper extends HTMLElement {
        constructor() {
            super();
            this.collectionSwiper = this.querySelector('.featured-collection-group-swiper__swiper');
            this.productSwipers = this.querySelectorAll('.featured-collection-group-swiper__swiper-products-swiper');
        }

        connectedCallback() {
            this.initSwiper();
            this.initSwitchButton();
        }

        initSwiper() {
            this.collectionSwiper = new Swiper(this.collectionSwiper, {
                slidesPerView: 1,
                spaceBetween: 0,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true,
                },
                allowTouchMove: false,
                autoHeight: true,
                on: {
                    init: function (swiper) {
                        // review DOM出现后，更新高度
                        const firstSlide = swiper.slides[0];
                        if (!firstSlide) return;

                        const productSwiper = firstSlide.querySelector('.featured-collection-group-swiper__swiper-products-swiper');
                        if (!productSwiper) return;

                        const firstSlideNode = productSwiper.querySelector('.swiper-slide');
                        if (!firstSlideNode) return;

                        const observer = new MutationObserver(() => {
                            this.update();
                        });

                        observer.observe(firstSlideNode, {
                            childList: true,
                            subtree: true
                        });

                        // 持续10s后移除observer
                        setTimeout(() => {
                            observer.disconnect();
                        }, 10000);
                    },
                    slideChange: function (swiper) {
                        const activeSlide = swiper.slides[swiper.activeIndex];
                        if (!activeSlide) return;
                        const productSwiperEl = activeSlide.querySelector('.featured-collection-group-swiper__swiper-products-swiper');
                        if (productSwiperEl && productSwiperEl.swiper) {
                            productSwiperEl.swiper.update();
                            swiper.updateAutoHeight(0);
                        }
                    },
                }
            });

            const desktopRows = this.dataset.rows === '2';
            const mobileRows = this.dataset.mobileRows === '2';
            const gridOne = { rows: 1, fill: 'column' };

            // Fewer products than the breakpoint can show: drop to one row and
            // size each card to the real count. Otherwise keep two rows, but
            // only reserve as many columns as the products need.
            const layoutForCount = (count, maxColumns, spaceBetween, groupByPage) => {
                const total = Math.max(count, 1);
                if (total <= maxColumns) {
                    return {
                        slidesPerView: total,
                        slidesPerGroup: groupByPage ? total : 1,
                        spaceBetween,
                        grid: { rows: 1, fill: 'row' },
                    };
                }
                const columns = Math.min(maxColumns, Math.ceil(total / 2));
                return {
                    slidesPerView: columns,
                    slidesPerGroup: groupByPage ? columns : 1,
                    spaceBetween,
                    grid: { rows: 2, fill: groupByPage ? 'row' : 'column' },
                };
            };

            const syncColumns = (instance) => {
                const perView = instance.params.slidesPerView;
                if (typeof perView === 'number') {
                    instance.el.style.setProperty('--columns', String(perView));
                } else {
                    instance.el.style.removeProperty('--columns');
                }
            };

            this.productSwipers.forEach((swiper) => {
                const count = swiper.querySelectorAll(':scope > .swiper-wrapper > .swiper-slide').length;
                const options = {
                    slidesPerView: 'auto',
                    pagination: {
                        el: swiper.querySelector('.swiper-pagination'),
                        clickable: true,
                    },
                    navigation: {
                        nextEl: swiper.parentElement.querySelector('.swiper_button_next'),
                        prevEl: swiper.parentElement.querySelector('.swiper_button_prev'),
                    },
                    a11y: {
                        enabled: false,
                    },
                };

                if (mobileRows || desktopRows) {
                    if (mobileRows) {
                        Object.assign(options, layoutForCount(count, 2, 10, true));
                    }

                    options.breakpoints = {};
                    if (desktopRows) {
                        options.breakpoints[750] = layoutForCount(count, 2, 0, false);
                        options.breakpoints[1001] = layoutForCount(count, 3, 0, false);
                        options.breakpoints[1201] = layoutForCount(count, 4, 0, false);
                        options.breakpoints[1401] = layoutForCount(count, 4, 5, false);
                    } else {
                        options.breakpoints[750] = { slidesPerView: 'auto', slidesPerGroup: 1, spaceBetween: 0, grid: gridOne };
                    }
                }

                const productSwiper = new Swiper(swiper, options);
                if (mobileRows || desktopRows) {
                    productSwiper.update();
                    syncColumns(productSwiper);
                    productSwiper.on('breakpoint', () => {
                        const grid = productSwiper.params.grid || {};
                        const usesOrder = grid.rows > 1 && grid.fill === 'row' && productSwiper.params.slidesPerGroup > 1;
                        let needsUpdate = false;
                        if (!usesOrder) {
                            productSwiper.slides.forEach((slideEl) => {
                                if (slideEl.style.order) {
                                    slideEl.style.order = '';
                                    slideEl.style.webkitOrder = '';
                                    needsUpdate = true;
                                }
                            });
                        }
                        if (needsUpdate) productSwiper.update();
                        syncColumns(productSwiper);
                        this.collectionSwiper.updateAutoHeight(0);
                    });
                }
            });

            if (mobileRows || desktopRows) {
                this.collectionSwiper.updateAutoHeight(0);
            }
        }

        initSwitchButton() {
            const switchButtons = this.querySelectorAll('.featured-collection-group-swiper__swiper-switch-button');
            switchButtons.forEach((button) => {
                button.addEventListener('click', () => {
                    const index = button.dataset.index;
                    this.collectionSwiper.slideTo(index);
                    switchButtons.forEach((btn) => btn.classList.remove('active'));
                    button.classList.add('active');
                });
            });
        }

        disconnectedCallback() {
        }
    }
    customElements.define('featured-collection-group-swiper', FeaturedCollectionGroupSwiper);
}